import api from './api';

export const getCustomersApi = params => {
  return api.get('/customers', {params});
};

export const getCustomerByIdApi = id => {
  return api.get(`/customers/${id}`);
};

export const getCustomerBySiteApi = (siteCode, siteNo) => {
  return api.get(`/customers/card-site`, {
    params: { siteCode, siteNo }  
  });
};

export const getCustomerByCodeApi = (code) => {
  return api.get(`/customers/card-code`, {
    params: { code }  
  });
};

export const getCustomersByBuildingApi = (buildingId, params) => {
  return api.get(`/customers/building/${buildingId}`, {params});
};

export const getCustomersByEntraceApi = (entranceId, params) => {
  return api.get(`/customers/entrance/${entranceId}`, {params});
};

export const addCustomerApi = params => {
  return api.post('/customers', params);
};

export const editCustomerApi = params => {
  return api.put('/customers', params);
};

export const deleteCustomerApi = id => {
  return api.delete(`/customers/${id}`);
};

export const addNoteApi = payload => api.post('notes', payload);
export const getNotesApi = customerId =>
  api.get(`/notes/customer/${customerId}`);
